export class GlobalConstants {

      // Local Server
      // public static apiURL: string = 'http://localhost:8090/';
      // public static domainURL: string = 'http://localhost:4200';
    
      // Live Server
       public static apiURL: string = 'https://beta.cviewsurvey.com:8090/';
       public static domainURL: string = 'https://beta.cviewsurvey.com';
    
      // Test/Development Server
      // public static domainURL: string = 'http://cviewsurvey.coworrk.com';
      // public static apiURL: string = 'http://coworrk.com:8090/';
    
}